import styles from './ModalSpinner.module.scss';

export const ModalSpinner = () => {
  return <div className={styles.spinner}></div>;
};
